import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { bodyMd } from '@helpers/typography';
import styled, { css } from 'styled-components';
export const CommonTextInputStyles = css `
  ${fonts.montserrat.regular};
  --borderColour: ${brand.ngbBlue.default};
  --borderRadius: 1000px;
  --placeholderColour: ${brand.neutrals[400]};
  --readOnlyColour: ${brand.neutrals[500]};
  --textColour: ${brand.ngbBlue.default};
  --paddingY: 14px;
  --paddingX: 16px;

  /* Ensure iOS doesn't apply default border radius */
  appearance: none;
  -webkit-appearance: none !important;
  display: block;
  background-color: transparent !important;
  border: 1px solid var(--borderColour) !important;
  border-radius: var(--borderRadius);
  ${bodyMd}
  ${fonts.montserrat.regular};
  color: var(--textColour);
  margin: 0;
  padding: var(--paddingY) var(--paddingX);
  width: 100%;

  &:disabled {
    opacity: 0.5;
    color: var(--readOnlyColour);
    cursor: not-allowed;
  }

  &::placeholder {
    color: var(--placeholderColour);
    position: relative;
    bottom: 1px;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }
`;
const Input = styled.input `
  ${CommonTextInputStyles};
`;
const TextboxStyles = {
    Input,
};
export default TextboxStyles;
